module.exports = __webpack_public_path__ + "static/media/bell-on-light.9d50000f.svg";